// extracted by mini-css-extract-plugin
module.exports = {"grid":"quickcategory_grid__2sVLc"};